'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cartSelector = exports.cartGroupedSelector = undefined;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _reselect = require('reselect');

var _cart = require('@arreeba/ristoranti-lib/lib/cart');

var _cart2 = _interopRequireDefault(_cart);

var _constants = require('../constants');

var _common = require('./common');

var _voucher = require('./voucher');

var _voucher2 = require('../helpers/voucher');

var _voucher3 = _interopRequireDefault(_voucher2);

var _i18n = require('../helpers/i18n');

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var cartGroupedSelector = exports.cartGroupedSelector = (0, _reselect.createSelector)(_common.currentOrderSelector, function (order) {
  if (!order && !order.id) {
    return {};
  }

  return _lodash2.default.values(_lodash2.default.groupBy(order.cart, function (item) {
    // plain items
    if (item.modifiers.length === 0) {
      return item.id;
    }
    // item with modifiers
    return item.cart_id || Math.random().toString(16);
  })).sort(function (group1, group2) {
    if (group1[0].name >= group2[0].name) {
      return 1;
    }
    return -1;
  });
});

var cartSelector = exports.cartSelector = function cartSelector(localizedLabels) {
  return (0, _reselect.createSelector)(_common.currentOrderSelector, _voucher.usableVouchersSelector, function (order, voucher) {
    if (!order || !order.orderType) {
      return null;
    }

    // filteredVouchers should be null if there are no usable vouchers (e.g. they were not fetched).
    var filteredVouchers = !voucher ? null : _voucher3.default.voucherForService(voucher, 'order', order.orderType);

    // if is an archived order the extra costs are already
    // serialized thus we don't need to filter by order type
    var extraCosts = Array.isArray(order.extraCosts) ? [].concat(_toConsumableArray(order.extraCosts)) :
    // use [] to prevent crash (babel toConsumableArray err) if there's
    // no extraCosts for this orderType
    [].concat(_toConsumableArray(order.extraCosts[order.orderType] || []));

    var extraCostsVoucher = null;
    var voucherAmountString = null;

    if (order.selectedVoucher && order.selectedVoucher !== _constants.ORDER_NO_VOUCHER) {
      var voucherData = _voucher3.default.getVoucherWithId(filteredVouchers, order.selectedVoucher);
      var language = _i18n2.default.currentLanguage(localizedLabels.language);
      var voucherFormatted = _voucher3.default.format(voucherData, localizedLabels, language);

      voucherAmountString = voucherData && voucherData.discount && voucherData.discount.format !== _constants.VOUCHER_FORMAT_FREE_ITEM ? voucherFormatted ? '- ' + voucherFormatted.subtitle : '' : "";

      if (voucherData) {
        extraCostsVoucher = _cart2.default.extraCostFromVoucher(voucherData, order.cart);
        extraCosts.push(extraCostsVoucher);
      }
    }

    var subtotal = _cart2.default.subTotal(order.cart);

    // total all inclusive (delivery costs, voucher and other stuff)
    // if is an archived order use the fixed total field
    var total = order.total ? order.total : _voucher3.default.cartTotalWithVoucher(order.cart, order.extraCosts[order.orderType], order.selectedVoucher, filteredVouchers);

    // total without extra costs like delivery but with voucher discount applied
    var totalNoExtraCosts = _voucher3.default.cartTotalWithVoucher(order.cart, [], order.selectedVoucher, filteredVouchers);

    return {
      voucherAmountString: voucherAmountString,
      extraCosts: extraCosts,
      subtotal: subtotal,
      total: total,
      totalNoExtraCosts: totalNoExtraCosts,
      vouchers: !filteredVouchers ? null : [{
        id: _constants.ORDER_NO_VOUCHER,
        message: 'Nessuno sconto'
      }].concat(filteredVouchers)
    };
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/lib/selectors/cart.js
// module id = 115
// module chunks = 0